import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["disabled", "className", "defaultValue", "onChange", "onFocus", "onBlur", "errorLabel", "haveLabel", "placeholder", "inputWrapperClassName", "direction", "errorLabelClassName", "inputClassName"];
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import stl from "./InputPhoneNumber.module.css";
import { useTranslation } from "@i18n";
import { If } from "@componentsShared/Conditional/If";
var InputPhoneNumber = function InputPhoneNumber(_ref) {
  var disabled = _ref.disabled,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    errorLabel = _ref.errorLabel,
    _ref$haveLabel = _ref.haveLabel,
    haveLabel = _ref$haveLabel === void 0 ? true : _ref$haveLabel,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    _ref$inputWrapperClas = _ref.inputWrapperClassName,
    inputWrapperClassName = _ref$inputWrapperClas === void 0 ? "" : _ref$inputWrapperClas,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "rtl" : _ref$direction,
    _ref$errorLabelClassN = _ref.errorLabelClassName,
    errorLabelClassName = _ref$errorLabelClassN === void 0 ? "" : _ref$errorLabelClassN,
    inputClassName = _ref.inputClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useState = useState(defaultValue || ""),
    displayValue = _useState[0],
    setDisplayValue = _useState[1];
  var _useState2 = useState(false),
    isfocused = _useState2[0],
    setIsfocused = _useState2[1];
  var maxLength = 10;
  var label = t("رقم الجوال", {
    ns: "web_common"
  });
  useEffect(function () {
    setDisplayValue(defaultValue || "");
  }, [defaultValue]);

  // Normalize input to allow only Arabic or English numbers
  var normalizeInput = function normalizeInput(input) {
    var arabicToEnglishMap = {
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9"
    };
    return input.replace(/[٠-٩]/g, function (_char) {
      return arabicToEnglishMap[_char] || _char;
    }) // Convert Arabic to English numerals
    .replace(/[^0-9]/g, "") // Remove non-numeric characters
    .slice(0, maxLength); // Enforce max length
  };

  // Handle input changes
  var handleInputChange = function handleInputChange(e) {
    var rawValue = normalizeInput(e.target.value); // Normalize input
    setDisplayValue(rawValue); // Update display value
    onChange(rawValue); // Notify parent
  };

  // Handle key press events and validate Arabic input
  var handleKeyPress = function handleKeyPress(e) {
    var arabicToEnglishMap = {
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9"
    };
    if (e.key in arabicToEnglishMap) {
      // Prevent the default Arabic character from being input
      e.preventDefault();
      var englishEquivalent = arabicToEnglishMap[e.key];
      var newValue = normalizeInput(displayValue + englishEquivalent);
      setDisplayValue(newValue);
      onChange(newValue);
    }
  };

  // Validate input after paste
  var handleInput = function handleInput(e) {
    var inputElement = e.target;
    var rawValue = normalizeInput(inputElement.value); // Normalize input
    setDisplayValue(rawValue); // Update display value
    onChange(rawValue); // Notify parent
  };
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.mainContainer, className !== null && className !== void 0 ? className : undefined, isfocused ? stl.mainFocus : undefined, disabled ? stl.disabled : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.inputWrapper, errorLabel ? stl.errorStyle : undefined, inputWrapperClassName].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.inputContainer, " ").concat(displayValue || isfocused ? stl.focused : "")
  }, /*#__PURE__*/React.createElement(If, {
    condition: haveLabel
  }, /*#__PURE__*/React.createElement("label", {
    className: stl.label
  }, label)), /*#__PURE__*/React.createElement("input", _extends({
    type: "text",
    inputMode: "numeric",
    pattern: "[0-9]*",
    dir: direction,
    placeholder: placeholder,
    className: [stl.inputField, inputClassName].join(" "),
    value: displayValue,
    onChange: handleInputChange,
    onInput: handleInput // Handle paste or other direct input
    ,
    onKeyDown: handleKeyPress // Convert Arabic numerals to English on key press
    ,
    onFocus: function onFocus() {
      _onFocus && _onFocus();
      setIsfocused(true);
    },
    onBlur: function onBlur() {
      setIsfocused(false);
      _onBlur && _onBlur();
    },
    maxLength: maxLength
  }, props)))), errorLabel && /*#__PURE__*/React.createElement("span", {
    className: [stl.errorLabel, errorLabelClassName].join(" ")
  }, errorLabel));
};
export default InputPhoneNumber;